module.exports = __webpack_public_path__ + "static/media/Eve_transparent.0426e3a4.webp";